<template>
  <div class="fixedflexcn loginbg paddinglogin" :style="{backgroundImage: `url(${WebSetting.bgpicture})`}">
    <div class="row m-0 incontainerlg">
      <div class="col-md-5 col-lg-6 d-none d-md-flex p-0 flexcn">
        <div class="leftcartoon animate__animated animate__bounce">
          <!--<img src="./../assets/icon/captaind.png" />-->
          <img :src="WebSetting.banner" />
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-6 p-0 px-1 px-md-2 px-lg-4 flexcn">
        <div class="bginputlogin" :style="{ backgroundImage: createBackgroundString }">
          <img class="ic-lg-01" src="./../assets/icon/06.png" />
          <img class="ic-lg-02" src="./../assets/icon/02.png" />
          <div class="logologin">
            <img :src="WebSetting.logo" />
          </div>
          <div class="inbgbeforelogin">
            <div class="insidectloginmb">
              <div class="headerlogin my-2">
                <h2>เข้าสู่ระบบ</h2>
              </div>
              <form>
                <div>
                  <div class="form-group my-2">
                    <div>
                      <label>เบอร์โทรศัพท์</label>
                      <div class="el-input my-1">
                        <i class="fas fa-user"></i>
                        <input
                          type="text"
                          id="phone"
                          v-model="FormLogin.phone"
                          placeholder="เบอร์โทรศัพท์"
                          class="inputstyle"
                          maxlength="10"
                          @keyup.enter="onClickLogin"
                          pattern="[0-9]*"
                          inputmode="numeric"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group my-4">
                    <div>
                      <label>รหัสผ่าน</label>
                      <div class="el-input my-1">
                        <i class="fas fa-lock"></i>
                        <input
                          type="password"
                          id="password"
                          v-model="FormLogin.password"
                          placeholder="รหัสผ่าน"
                          class="inputstyle"
                          @keyup.enter="onClickLogin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <button type="button" class="loginbtn mt-3" @click="onClickLogin">
                <span> เข้าสู่ระบบ </span>
              </button>
              <div class="wantregister">
                หากท่านยังไม่มีบัญชีสมาชิก ?
                <router-link class="text-primary" to="/register"
                  ><u>สมัครเลย</u></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";

export default {
  name: "LoginPage",
  components: {},
  data() {
    return {
      tempURL:"../img/10.jpg",
      primaryColor:"#001c4d",
      FormLogin: {
        phone: "",
        password: "",
      },
    };
  },
  metaInfo() {
    return {
      title: this.WebSetting.title,
      link: [
        {
          rel: "icon",
          href: this.WebSetting.logo,
        },
      ],
    };
  },
  mounted() {
    this.fetchWebSetting();
  },
  methods: {
    fetchWebSetting() {
      HTTP.get(`system/info`)
        .then((resp) => {
          this.$store.dispatch("savePageSetting", resp.data.data);
          if(resp.data.data != null && resp.data.data.color1 != null)
          {
            this.primaryColor = resp.data.data.color1;
          }          
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    onClickLogin() {
      if (this.FormLogin.phone != "" && this.FormLogin.password != "") {
        if (!isNaN(this.FormLogin.phone)) {
          if (this.FormLogin.phone.length == 10) {
            HTTP.post(`member/login`, {
              phone: this.FormLogin.phone,
              password: this.FormLogin.password,
            })
              .then((resp) => {
                if (resp.data.status != undefined && !resp.data.status) {
                  this.$swal.fire({
                    text:
                      resp.data.msg != undefined
                        ? resp.data.msg
                        : "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                  });
                } else {
                  if (resp.data.status != undefined && resp.data.status) {
                    this.$store.dispatch("loginAuth", resp.data);
                    this.$router.push("/");
                  }
                }
              })
              .catch((err) => {
                this.$swal.fire({
                  text:
                    err.data.msg != undefined
                      ? err.data.msg
                      : "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่",
                  icon: "error",
                  confirmButtonText: "ตกลง",
                });
              });
          } else {
            this.$swal.fire({
              text: "เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลักเท่านั้น",
              icon: "error",
              confirmButtonText: "ตกลง",
            });
          }
        } else {
          this.$swal.fire({
            text: "เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น",
            icon: "error",
            confirmButtonText: "ตกลง",
          });
        }
      } else {
        this.$swal.fire({
          text: "กรอกข้อมูลให้ครบถ้วน",
          icon: "error",
          confirmButtonText: "ตกลง",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(348deg, #000000, ${this.primaryColor}), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    }
  },
};
</script>
